import PeopleFirst from './PeopleFirst';
export default PeopleFirst;